import { render, staticRenderFns } from "./editOrderDespatchDialog.vue?vue&type=template&id=83996ca8&"
import script from "./editOrderDespatchDialog.vue?vue&type=script&lang=js&"
export * from "./editOrderDespatchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports